import React from "react";
import TableRow from "./TableRow";


const TableBody = (props) => {
  const sliceStart = props.numberItems * (props.currentPage - 1);
  const sliceEnd = sliceStart + parseInt(props.numberItems);
  return (
    <div className="finderTable-body">
      {props.table.slice(sliceStart, sliceEnd).map((row, index) => (
        <TableRow config={props.config} header={props.header} key={index} row={row} idx={row[0].id} />
      ))}
    </div>
  );
};
export default TableBody;
